import React from "react";

/** Mavtech Mobile Tires wordmark + tire emblem */
export const Logo = ({ dark = false, compact = false, className = "" }) => {
  const text = dark ? "text-white" : "text-brand-black";
  return (
    <a href="/" className={`inline-flex items-center gap-2.5 ${className}`} data-testid="site-logo">
      <TireEmblem />
      {!compact && (
        <span className={`font-display font-extrabold tracking-tight text-lg sm:text-xl ${text}`}>
          MAVTECH
          <span className="text-brand-red">.</span>
          <span className={dark ? "text-white/70" : "text-neutral-500"}>tires</span>
        </span>
      )}
    </a>
  );
};

export const TireEmblem = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill="#0A0A0A" />
    <circle cx="32" cy="32" r="11" fill="none" stroke="#E60000" strokeWidth="3" />
    <g stroke="#FFFFFF" strokeWidth="3" strokeLinecap="round">
      <line x1="32" y1="6" x2="32" y2="16" />
      <line x1="32" y1="48" x2="32" y2="58" />
      <line x1="6" y1="32" x2="16" y2="32" />
      <line x1="48" y1="32" x2="58" y2="32" />
      <line x1="14" y1="14" x2="21" y2="21" />
      <line x1="43" y1="43" x2="50" y2="50" />
      <line x1="50" y1="14" x2="43" y2="21" />
      <line x1="21" y1="43" x2="14" y2="50" />
    </g>
  </svg>
);

export default Logo;
